<nav [class.open]="open">
  <div class="nav-inner">

    <ul *ngIf="reportCategories" class="nav-ul">
      <ng-container *ngFor="let category of reportCategories">
        <li *ngIf="category.name != 'Hidden' && category.options?.length" [class.active]="category.active" (click)="toggleCategory(category)">
          <a>{{category.name}}</a>
          <ul *ngIf="category.options">
            <li *ngFor="let report of category.options" class="report-item">
              <a [routerLink]="['/reports', report.key]" (click)="setActiveReport(report)">{{report.name}}</a>
              <ul *ngIf="variantsFeatureEnabled && report.variants?.length" class="variants-sublist">
                <li *ngFor="let variant of report.variants" class="variant-item">
                  <a [routerLink]="['/reports', report.key]"
                     [queryParams]="{variant: variant.key}"
                     (click)="setActiveReport(report)"
                     [class.is-default]="variant.key === report.defaultVariantKey">
                    <span class="variant-bullet">›</span>
                    <span class="variant-name">{{variant.name}}</span>
                    <span *ngIf="variant.key === report.defaultVariantKey" class="default-mark" title="Default">★</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>

  </div>
</nav>
<div class="nav-toggle" [class.open]="open" (click)="toggleMenu()"></div>
